import {useSelector,useDispatch} from 'react-redux'
import axios from 'axios'
import {useState} from 'react'
import gif from './loading.gif'




function MenuNews (props){
  const data = useSelector(state => state.news)
  const dispatch = useDispatch()
  const [load,setLoad] = useState(false)
  
  
  function getData (){
      axios.get(`/?id=WIrbis&action=Conference/GetNews&sid=${props.sid}`).then((resp) => {
        dispatch ({type:'TABLE_LOAD_NEWS',payload1: resp.data})
        setLoad(true)
     
        
    })
    }
 

    if (load === false) {
      return <p ><img onLoad={getData()} src={gif} width='50' height='50'/> </p>
  }
    else{

    return(
        <div className={props.active ? 'menu-table-active' : 'menu-table' }  id="menu-table1" >
        <table className="table" >
          <tbody>
             
                
          {
                data.map((n) =>{
                    return(
                  <tr key={n.date}>
                    <td>{n.date}</td>
                    <td>{n.newsText}</td>
                  </tr>)}
                )      
                          
                      
          }
               
              

             
          </tbody>
        </table>
      </div>







    );
            }
}




export default MenuNews